/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'sarsaparilla';

import InventoryReviewsSection from 'ui-rating-review/src/containers/InventoryReviewsSection';

const propTypes = {
    permitId: PropTypes.string,
    children: PropTypes.node,
    isVehicle: PropTypes.bool,
};

export default function VenueTabWrapper({ permitId, children, isVehicle }) {
    return (
        <Stack>
            {children}
            <InventoryReviewsSection
                locationType={isVehicle ? 'Vehicle Permit' : 'Permit'}
                locationId={permitId}
                className="content-section"
            />
        </Stack>
    );
}

VenueTabWrapper.propTypes = propTypes;
